import { useContext } from "react";
import { useSelector } from "react-redux";
import { ZoneProjectReport } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  reports: ZoneProjectReport[];
  retrieveZonesProjectsReports(
    request: Boundaries["retrieveZonesProjectsReports"]["request"],
  ): void;
}

function useRetrieveZonesProjectsReports(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isZonesProjectsReportsRetrievalRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isZonesProjectsReportsRetrievalRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isZonesProjectsReportsRetrievalRequestFailure,
    ),
    reports: useSelector(selector.getZonesProjectsReports),
    retrieveZonesProjectsReports: core.retrieveZonesProjectsReports,
  };
}

export { useRetrieveZonesProjectsReports };
